var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTopten(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    height: 1080,
    viewBox: "0 0 1080 1080",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.2.4")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "ac932512-146f-4350-9fe5-f3e728b36ea4"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: -540,
    y: -540,
    rx: 0,
    ry: 0,
    width: 1080,
    height: 1080
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "1357df72-bb7d-4f1e-86d6-c1ab9cda8783"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(38.57 0 0 38.57 540 540)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(229,9,20)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    x: -14,
    y: -15,
    rx: 3,
    ry: 3,
    width: 28,
    height: 30
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 2.82 3.93)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-16.82, -18.93)",
    d: "M 16.8211527 22.1690594 C 17.4133103 22.1690594 17.8777709 21.8857503 18.2145345 21.3197261 C 18.5512982 20.7531079 18.719977 19.9572291 18.719977 18.9309018 C 18.719977 17.9045745 18.5512982 17.1081018 18.2145345 16.5414836 C 17.8777709 15.9754594 17.4133103 15.6921503 16.8211527 15.6921503 C 16.2289952 15.6921503 15.7645345 15.9754594 15.427177 16.5414836 C 15.0904133 17.1081018 14.9223285 17.9045745 14.9223285 18.9309018 C 14.9223285 19.9572291 15.0904133 20.7531079 15.427177 21.3197261 C 15.7645345 21.8857503 16.2289952 22.1690594 16.8211527 22.1690594 M 16.8211527 24.0708533 C 15.9872618 24.0708533 15.2579042 23.8605988 14.6324861 23.4406836 C 14.0076618 23.0207685 13.5247891 22.4262352 13.1856497 21.6564897 C 12.8465103 20.8867442 12.6766436 19.9786109 12.6766436 18.9309018 C 12.6766436 17.8921018 12.8465103 16.9857503 13.1856497 16.2118473 C 13.5247891 15.4379442 14.0076618 14.8410352 14.6324861 14.4205261 C 15.2579042 14.0006109 15.9872618 13.7903564 16.8211527 13.7903564 C 17.6544497 13.7903564 18.3844012 14.0006109 19.0098194 14.4205261 C 19.6352376 14.8410352 20.1169224 15.4379442 20.4566558 16.2118473 C 20.7952012 16.9857503 20.9656618 17.8921018 20.9656618 18.9309018 C 20.9656618 19.9786109 20.7952012 20.8867442 20.4566558 21.6564897 C 20.1169224 22.4262352 19.6352376 23.0207685 19.0098194 23.4406836 C 18.3844012 23.8605988 17.6544497 24.0708533 16.8211527 24.0708533",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -5.02 3.88)"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    points: "-0.11,5.03 -0.11,-2.22 -2.1,-1.7 -2.1,-3.96 2.1,-5.03 2.1,5.03 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 6.98 -5.47)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-20.98, -9.53)",
    d: "M 20.0388194 9.42258545 L 20.8085648 9.42258545 C 21.1886861 9.42258545 21.4642739 9.34834303 21.6353285 9.19926424 C 21.806383 9.05077939 21.8919103 8.83993091 21.8919103 8.56731273 C 21.8919103 8.30122788 21.806383 8.09572485 21.6353285 7.94961576 C 21.4642739 7.80410061 21.1886861 7.73104606 20.8085648 7.73104606 L 20.0388194 7.73104606 L 20.0388194 9.42258545 Z M 18.2332436 12.8341733 L 18.2332436 6.22006424 L 21.0936558 6.22006424 C 21.6323588 6.22006424 22.0974133 6.31806424 22.4906012 6.51465818 C 22.8831952 6.71125212 23.1872921 6.98684 23.4028921 7.34142182 C 23.6178982 7.69659758 23.7259952 8.10522788 23.7259952 8.56731273 C 23.7259952 9.04246424 23.6178982 9.45762788 23.4028921 9.8122097 C 23.1872921 10.1667915 22.8831952 10.4429733 22.4906012 10.6389733 C 22.0974133 10.8355673 21.6323588 10.9335673 21.0936558 10.9335673 L 20.0388194 10.9335673 L 20.0388194 12.8341733 L 18.2332436 12.8341733 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0.07 -5.47)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-14.07, -9.53)",
    d: "M 14.0706788 11.3992752 C 14.3937818 11.3992752 14.6770909 11.322063 14.9212 11.1664509 C 15.1653091 11.0114327 15.3553697 10.792863 15.4913818 10.5107418 C 15.6279879 10.2286206 15.695697 9.90136 15.695697 9.52717818 C 15.695697 9.1535903 15.6279879 8.82573576 15.4913818 8.54361455 C 15.3553697 8.26149333 15.1653091 8.04351758 14.9212 7.88790545 C 14.6770909 7.73288727 14.3937818 7.65508121 14.0706788 7.65508121 C 13.7475758 7.65508121 13.4642667 7.73288727 13.2201576 7.88790545 C 12.9760485 8.04351758 12.7859879 8.26149333 12.6499758 8.54361455 C 12.5139636 8.82573576 12.4456606 9.1535903 12.4456606 9.52717818 C 12.4456606 9.90136 12.5139636 10.2286206 12.6499758 10.5107418 C 12.7859879 10.792863 12.9760485 11.0114327 13.2201576 11.1664509 C 13.4642667 11.322063 13.7475758 11.3992752 14.0706788 11.3992752 M 14.0706788 12.9957842 C 13.5634545 12.9957842 13.0995879 12.9090691 12.6784848 12.7344509 C 12.2573818 12.5604267 11.8915152 12.3163176 11.5808848 12.0027176 C 11.2708485 11.6891176 11.0314909 11.322063 10.8634061 10.9003661 C 10.6953212 10.479263 10.6115758 10.0213358 10.6115758 9.52717818 C 10.6115758 9.03302061 10.6953212 8.57568727 10.8634061 8.1539903 C 11.0314909 7.73288727 11.2708485 7.36523879 11.5808848 7.05163879 C 11.8915152 6.73803879 12.2573818 6.49452364 12.6784848 6.31990545 C 13.0995879 6.14588121 13.5634545 6.05857212 14.0706788 6.05857212 C 14.577903 6.05857212 15.0417697 6.14588121 15.4628727 6.31990545 C 15.8839758 6.49452364 16.2498424 6.73803879 16.5604727 7.05163879 C 16.871103 7.36523879 17.1098667 7.73288727 17.2779515 8.1539903 C 17.4460364 8.57568727 17.5297818 9.03302061 17.5297818 9.52717818 C 17.5297818 10.0213358 17.4460364 10.479263 17.2779515 10.9003661 C 17.1098667 11.322063 16.871103 11.6891176 16.5604727 12.0027176 C 16.2498424 12.3163176 15.8839758 12.5604267 15.4628727 12.7344509 C 15.0417697 12.9090691 14.577903 12.9957842 14.0706788 12.9957842",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -6.44 -5.26)"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    points: "0.9,3.09 -0.9,3.52 -0.9,-1.96 -2.91,-1.96 -2.91,-3.52 2.91,-3.52 2.91,-1.96 0.9,-1.96 "
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopten);
export default __webpack_public_path__ + "static/media/topten.6f7371f9ba2525b92075b4fd4383da4d.svg";
export { ForwardRef as ReactComponent };